package com.example.mystybag.common.views

import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.DatePickerDefaults
import androidx.compose.material3.DatePickerDialog
import androidx.compose.material3.DateRangePicker
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.DateRangePickerDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.SelectableDates
import androidx.compose.material3.TextButton
import androidx.compose.material3.rememberDateRangePickerState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.extensions.capitalizeFirst
import com.example.mystybag.core.ui.theme.LocalTheme.p28
import com.example.mystybag.core.ui.theme.LocalTheme.p4
import com.example.mystybag.core.ui.theme.LocalTheme.p500
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.common.ui.components.native.Texts
import io.ktor.util.date.WeekDay
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DateRangePickerDialog(
    selectableDates     : Pair<Long?, Long?>,
    selectableDays      : List<WeekDay>? = null,
    yearsList           : List<Int>,
    selectedStartDate   : Long?,
    selectedEndDate     : Long?,
    onDismiss           : () -> Unit,
    onPositiveClicked   : (startDate: Long?, endDate: Long?) -> Unit
) {
    val dateRangePickerState = rememberDateRangePickerState(
        selectableDates = object : SelectableDates {
            override fun isSelectableDate(utcTimeMillis: Long): Boolean {
                return (
                    selectableDates.let { period ->
                        period.first?.let { startDate ->
                            period.second?.let { max -> utcTimeMillis in startDate..max } ?: run { utcTimeMillis >= startDate }
                        } ?: run { period.second?.let { endDate -> utcTimeMillis <= endDate } ?: false } && selectableDays?.map { days ->
                            days.ordinal
                        }?.contains(Instant.fromEpochMilliseconds(utcTimeMillis).toLocalDateTime(TimeZone.currentSystemDefault()).dayOfWeek.ordinal) ?: true
                    }
                )
            }

            override fun isSelectableYear(year: Int): Boolean {
                return yearsList.contains(year)
            }
        },
        initialSelectedStartDateMillis  = selectedStartDate,
        initialSelectedEndDateMillis    = selectedEndDate,
        yearRange                       = if (yearsList.isNotEmpty()) IntRange(yearsList.first(), yearsList.last()) else DatePickerDefaults.YearRange
    )

    val surfaceColor = AppTheme.current.colors.surface
    MaterialTheme(
        colorScheme = MaterialTheme.colorScheme.copy(
            surface = surfaceColor,
            surfaceContainerLowest = surfaceColor,
            surfaceContainerLow = surfaceColor,
            surfaceContainer = surfaceColor,
            surfaceContainerHigh = surfaceColor,
            surfaceContainerHighest = surfaceColor
        )
    ) {
    DatePickerDialog(
        colors = DatePickerDefaults.colors(
            containerColor = surfaceColor
        ),
        confirmButton       = {
            TextButton(
                modifier    = Modifier.padding(end = p4),
                onClick     = { onPositiveClicked(dateRangePickerState.selectedStartDateMillis, dateRangePickerState.selectedEndDateMillis) }
            ) {
                Texts.BodyLarge(
                    text    = sharedString(SR.strings.save),
                    color   = AppTheme.current.colors.primary
                )
            }
        },
        onDismissRequest    = onDismiss,
        dismissButton       = {
            TextButton(onDismiss) {
                Texts.BodyLarge(sharedString(SR.strings.cancel).lowercase().capitalizeFirst())
            }
        }
    ) {
        DateRangePicker(
            modifier    = Modifier.heightIn(max = p500),
            state       = dateRangePickerState,
            title       = null,
            colors      = DatePickerDefaults.colors().copy(
                dayInSelectionRangeContainerColor   = AppTheme.current.colors.primaryContainer,
                dayInSelectionRangeContentColor     = AppTheme.current.colors.onPrimaryContainer
            ),
            headline = {
                DateRangePickerDefaults.DateRangePickerHeadline(
                    selectedStartDateMillis     = selectedStartDate,
                    selectedEndDateMillis       = selectedEndDate,
                    displayMode                 = dateRangePickerState.displayMode,
                    dateFormatter               = DatePickerDefaults.dateFormatter(),
                    modifier                    = Modifier.padding(start = p28)
                )
            },
        )
    }
    }
}